import { useMemo } from "react";
import type { Options } from "react-select";

import type { Customer } from "../../../common/graphql/fragments/gql/Customer";
import {
  type DropdownOption,
  transformCustomer,
} from "../../../common/utils/optionTransformers";
import { useAllIntermodalCustomers } from "./useAllIntermodalCustomers";

export const useAllIntermodalCustomersAsOptions = (options?: {
  includeClosedCustomers?: boolean;
}): Options<DropdownOption<Customer>> => {
  const customers = useAllIntermodalCustomers(options);

  return useMemo(() => customers.map((c) => transformCustomer(c)), [customers]);
};
